interface WhyNowProps {
  scrollToConsultation: () => void;
}

export default function WhyNow({ scrollToConsultation }: WhyNowProps) {
  const reasons = [
    {
      icon: 'ri-infinity-line',
      title: '평생 이행강제금 vs 단 한 번의 양성화',
      description: '2019년 법 개정으로 이행강제금 부과 횟수 제한이 폐지되어, 시정될 때까지 평생 부과됩니다. 이번 5회분 납부로 영구적인 면제를 받으세요.',
    },
    {
      icon: 'ri-drone-line',
      title: 'AI 단속 시스템 본격 가동',
      description: '이제 공무원이 눈으로 확인하지 않습니다. AI 항공 촬영과 드론이 10cm의 오차도 잡아냅니다. 숨길 수 없는 시대, 합법화가 유일한 답입니다.',
    },
    {
      icon: 'ri-line-chart-line',
      title: '부동산 가치 상승과 대출 정상화',
      description: '위반 딱지가 붙은 건물은 전세자금대출 불가, 매매 시 대출 제한을 받습니다. 양성화 즉시 정상 시세로 매도가 가능해지며, 세입자의 전세보증보험 가입도 가능해집니다.',
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        {/* Title */}
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            지금 당장 준비해야 하는 이유
          </h2>
          <p className="text-lg text-gray-500 font-light">
            2026년 특별법은 단 1년만 시행됩니다
          </p>
        </div>

        {/* CTA Button */}
        <div className="text-center mb-16">
          <button
            onClick={scrollToConsultation}
            className="bg-[#5C4033] text-white px-10 py-4 rounded-full text-lg font-semibold hover:bg-[#4a3329] transition-all duration-300 hover:scale-105 inline-flex items-center gap-3 shadow-xl whitespace-nowrap"
          >
            무료 사전 진단 신청하기
            <i className="ri-arrow-right-line text-xl"></i>
          </button>
        </div>

        {/* Reasons Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-[#F5F3EF] to-white rounded-2xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className="flex justify-center mb-6">
                <div className="w-20 h-20 bg-[#2C4A3E] rounded-full flex items-center justify-center">
                  <i className={`${reason.icon} text-4xl text-white`}></i>
                </div>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4 text-center leading-snug">
                {reason.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed text-center">
                {reason.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
